var CLUSTERS;
(function (CLUSTERS) {
    CLUSTERS["HR"] = "hr";
    CLUSTERS["CONSTRUCTION"] = "construction";
    CLUSTERS["DESIGN_AND_CREATIVE"] = "design_and_creative";
    CLUSTERS["INFORMATION_TECHNOLOGY"] = "information_technology";
    CLUSTERS["NGO"] = "ngo";
    CLUSTERS["EDUCATION"] = "education";
    CLUSTERS["PMO"] = "pmo";
    CLUSTERS["FINANCE"] = "finance";
    CLUSTERS["MARKETING"] = "marketing";
    CLUSTERS["TECH"] = "tech";
    CLUSTERS["OPERATIONS"] = "operations";
    CLUSTERS["LEGAL"] = "legal";
    CLUSTERS["PRODUCT_MANAGEMENT"] = "product_management";
    CLUSTERS["CRM"] = "crm";
    CLUSTERS["PROJECTS_FLOW"] = "projects_flow";
    CLUSTERS["FUNDRAISING"] = "fundraising";
    CLUSTERS["SPACES"] = "spaces";
    CLUSTERS["APPSDEVELOPER"] = "appsdeveloper";
    CLUSTERS["WORK_MANAGEMENT"] = "work_management";
    CLUSTERS["OTHER"] = "other";
})(CLUSTERS || (CLUSTERS = {}));

export { CLUSTERS };
